import React, { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import { Loader, Text } from 'src/@vymo/ui/atoms';
import Button from 'src/@vymo/ui/atoms/button';
import { Card } from 'src/@vymo/ui/blocks';
import { Page } from 'src/@vymo/ui/molecules';
import classNames from 'classnames';
import { getAppHideConfig } from 'src/models/appConfig/selectors';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getIsLoading, getSummariseData } from '../selector';
import { summariseUI } from './thunk';
import styles from './index.module.scss';

function Summarise() {
  const dispatch = useAppDispatch();

  const summariseData = useAppSelector(getSummariseData);
  const isLoading = useAppSelector(getIsLoading);
  const hideSummarise = useAppSelector(getAppHideConfig).summarise;

  const [showSummariseCard, setShowSummariseCard] = React.useState(false);

  const onClickSummarise = useCallback(() => {
    setShowSummariseCard(true);
    // @ts-ignore
    dispatch(summariseUI());
  }, [dispatch]);

  if (hideSummarise) {
    return null;
  }

  const summariseCardClass = classNames(styles.summariseCard__container, {
    [styles.summariseCard__container__open]: showSummariseCard && !isLoading,
    [styles.summariseCard__container__closed]: !showSummariseCard,
  });

  return (
    <>
      {(!showSummariseCard || isLoading) && (
        <Loader className={styles.summariseButton} visible={isLoading}>
          <Button
            loading={isLoading}
            variant="filled"
            onClick={onClickSummarise}
          >
            Summarise
          </Button>
        </Loader>
      )}
      <div className={summariseCardClass}>
        {showSummariseCard && (
          <Card>
            <Page className={styles.summariseCard}>
              <Page.Header>
                <div className={styles.summariseCard__header}>
                  <Text type="h4"> Summary</Text>
                  <Button
                    type="outlined"
                    variant="filled"
                    onClick={() => setShowSummariseCard(false)}
                  >
                    Close
                  </Button>
                </div>
              </Page.Header>
              <Page.Body>
                <ReactMarkdown>{summariseData}</ReactMarkdown>
              </Page.Body>
            </Page>
          </Card>
        )}
      </div>
    </>
  );
}

export default Summarise;
